<h3 [ngClass]="{disabled: !formGroup.value.enabled}">{{'DASHBOARD.LOCAL_OFFICE.CONTACT.' + formGroup.value.label.toUpperCase() | translate}}</h3>
<div [formGroup]="formGroup">
  <eps-text-input
    label="email"
    formControlName="email"
    hideOptionalMarker
    labelWidth="150px"
    [clearable]="false"
    [disabled]="!formGroup.value.enabled"
    ></eps-text-input>
  <eps-text-input
    label="phone"
    formControlName="phoneNumber"
    hideOptionalMarker
    labelWidth="150px"
    [clearable]="false"
    [disabled]="!formGroup.value.enabled"
    ></eps-text-input>
  <eps-checkbox
    label="Enabled"
    formControlName="enabled"
    hideOptionalMarker
    labelWidth="150px"
    ></eps-checkbox>
</div>
